import type {
  DeepPartial, AreaSeriesOptions, LayoutOptions, Background, ChartOptions,
  CrosshairOptions, PriceScaleOptions, TimeScaleOptions
} from "lightweight-charts";
import { ColorType } from "lightweight-charts";

import { numberFormatters } from "../../../core/formatters";
import { NumberType } from "../../../core/formatters/number.formatter";

function getCssVariable(variable: string) {
  const value = getComputedStyle(document.body).getPropertyValue(variable);
  return value;
}

export const generationSeriesOption = (color: string) => Object.create({
  title: '', priceFormat: { type: 'price', precision: 0 },
  lineColor: color, topColor: color, bottomColor: color, lineWidth: 2,
  pointMaMarkersVisible: false,
  crosshairMarkerVisible: false,
  lastValueVisible: false
}) as DeepPartial<AreaSeriesOptions>

const background: Background = {
  type: ColorType.Solid, color: getCssVariable("--seashell")
}

const layout: DeepPartial<LayoutOptions> = {
  textColor: getCssVariable("--midnight-blue"),
  background,
  fontSize: 12,
  fontFamily: "Inter, sans-serif",
  attributionLogo: false,
}

const crosshair: DeepPartial<CrosshairOptions> = {
  horzLine: {
    visible: false,
    labelVisible: true,
    labelBackgroundColor: "#3442eb"
  },
  vertLine: {
    visible: false,
    labelVisible: false
  }
}

const leftPriceScale: DeepPartial<PriceScaleOptions> = {
  visible: true,
  autoScale: true,
  scaleMargins: {
    top: 0.2,
    bottom: 0
  }
}

const timeScale: DeepPartial<TimeScaleOptions> = {
  visible: true,
  ticksVisible: true,
  rightOffset: 0,
  fixLeftEdge: true,
  fixRightEdge: true,
}

export const defaultChartOptions: DeepPartial<ChartOptions> = {
  localization: { priceFormatter: (number: number) => numberFormatters.defaultFormat(number, NumberType.price) },
  layout,
  rightPriceScale: { visible: false },
  crosshair,
  handleScale: false,
  handleScroll: false,
  grid: {
    horzLines: {
      visible: true,
      color: getCssVariable("--light-grey")
    },
    vertLines: {
      visible: true,
      color: getCssVariable("--light-grey")
    }
  },
  autoSize: true,
  timeScale,
  leftPriceScale
}

export function generateCustomSeriesOptions(numberFormat: NumberType, top: number = 0, bottom: number = 0): DeepPartial<ChartOptions> {
  return Object.assign({}, defaultChartOptions, {
    localization: { priceFormatter: (number: number) => numberFormatters.defaultFormat(number, numberFormat) },
    crosshair,
    leftPriceScale: {
      visible: true,
      autoscale: true,
      scaleMargins: {
        top,
        bottom
      }
    }
  })
}

export function generateDualAxisChartOptions(numberFormat: NumberType, top: number = 0.2, bottom: number = 0.2): DeepPartial<ChartOptions> {
  return Object.assign({}, defaultChartOptions, {
    localization: { priceFormatter: (number: number) => numberFormatters.defaultFormat(number, numberFormat) },
    crosshair,
    rightPriceScale: {
      visible: true,
      autoScale: true,
      scaleMargins: {
        top,
        bottom
      }
    },
    leftPriceScale: {
      visible: true,
      autoScale: true,
      scaleMargins: {
        top: 0.2,
        bottom: 0.2
      }
    }
  })
}

